module.exports = __webpack_public_path__ + "media/packs/faq/images/header-img1-0f5fc27b85b470479cda8c2e1cf39332.svg";